import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { IBM_Plex_Mono, IBM_Plex_Sans } from 'next/font/google'

const sans = IBM_Plex_Sans({
    subsets: ['latin']
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500', '600']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
